import { ListItem as MuiListItem, type ListItemProps as MuiListItemProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiListItemProps, 'slots' | 'slotProps'>>;

export function ListItem(props: Props) {
  return <MuiListItem {...props} />;
}

export type { Props as ListItemProps };
